import { Box, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material";
import { Coordinate, } from "../../../types/types";
import { StyledText } from "../../TodoList/style/styles";

interface LocationSectionProps {
    isEditing: boolean;
    location?: Coordinate;
}

const LocationSection = ({ isEditing, location }: LocationSectionProps) => {
    const theme = useTheme();
    if (!location?.name && !isEditing) return null;

    return (
        <Box sx={{ mb: 3 }}>
            <Typography color="text.secondary" variant="subtitle2" gutterBottom>
                Location
            </Typography>
            <StyledText variant="body1" color={alpha(theme.palette.text.primary, 0.8)}>
                {location?.name || '-'}
            </StyledText>
        </Box>
    );
};

export default LocationSection;